<div class="flex flex-row items-center overflow-hidden text-base">
  <div
    [tp]="t1"
    [tpIsEnabled]="true"
    *ngIf="
      query?.status === queryStatusEnum.Completed &&
      showDataRowsLength === true &&
      showLastCompleteDuration === true
    "
    class="line-clamp-1 select-none"
  >
    <ng-template #t1>
      <div
        >{{ completedWord }} - {{ completedTimeAgo }} -
        {{ query.lastCompleteDuration }}s - {{ query.data.length }} rows</div
      >
    </ng-template>

    <ng-container *ngTemplateOutlet="t1"></ng-container>
  </div>

  <div
    [tp]="t2"
    [tpIsEnabled]="true"
    *ngIf="
      query?.status === queryStatusEnum.Completed &&
      showDataRowsLength === true &&
      showLastCompleteDuration === false
    "
    class="line-clamp-1 select-none"
  >
    <ng-template #t2>
      <div
        >{{ completedWord }} - {{ completedTimeAgo }} -
        {{ query.data.length }} rows</div
      >
    </ng-template>

    <ng-container *ngTemplateOutlet="t2"></ng-container>
  </div>

  <div
    [tp]="t3"
    [tpIsEnabled]="true"
    *ngIf="
      query?.status === queryStatusEnum.Completed &&
      showDataRowsLength === false &&
      showLastCompleteDuration === true
    "
    class="line-clamp-1 select-none"
  >
    <ng-template #t3>
      <div
        >{{ completedWord }} - {{ completedTimeAgo }} -
        {{ query.lastCompleteDuration }}s</div
      >
    </ng-template>

    <ng-container *ngTemplateOutlet="t3"></ng-container>
  </div>

  <div
    [tp]="t4"
    [tpIsEnabled]="true"
    *ngIf="
      query?.status === queryStatusEnum.Completed &&
      showDataRowsLength === false &&
      showLastCompleteDuration === false
    "
    class="line-clamp-1 select-none"
  >
    <ng-template #t4>
      <div>{{ completedWord }} - {{ completedTimeAgo }}</div>
    </ng-template>

    <ng-container *ngTemplateOutlet="t4"></ng-container>
  </div>

  <div
    [tp]="t5"
    [tpIsEnabled]="true"
    *ngIf="query?.status === queryStatusEnum.Running"
    class="flex flex-row items-center"
  >
    <div class="line-clamp-1 select-none">
      <ng-template #t5>
        <span>Running - seconds</span>
        <span class="ml-1 w-8">{{ runSecondsAgo }}</span>
      </ng-template>

      <ng-container *ngTemplateOutlet="t5"></ng-container>
    </div>

    <div class="relative ml-5 h-10 w-10">
      <ngx-spinner
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>
  </div>

  <div
    class="flex flex-row items-center"
    *ngIf="query?.status === queryStatusEnum.Error"
  >
    <div
      [tp]="t6"
      [tpIsEnabled]="true"
      class="bg-r100 text-r700 line-clamp-1 max-w-xl rounded px-3 py-2"
    >
      <div class="truncate break-words">
        <ng-template #t6>
          <div class="break-words">
            {{ query?.lastErrorMessage | capitalize }}
          </div>
        </ng-template>

        <ng-container *ngTemplateOutlet="t6"></ng-container>
      </div>
    </div>

    <div [tp]="t7" [tpIsEnabled]="true" class="ml-5 line-clamp-1 select-none">
      <ng-template #t7>
        <div>Error - {{ errorTimeAgo }}</div>
      </ng-template>

      <ng-container *ngTemplateOutlet="t7"></ng-container>
    </div>
  </div>

  <div
    [tp]="t8"
    [tpIsEnabled]="true"
    *ngIf="query?.status === queryStatusEnum.Canceled"
    class="line-clamp-1 select-none"
  >
    <ng-template #t8>
      <div>Canceled - {{ canceledTimeAgo }}</div>
    </ng-template>

    <ng-container *ngTemplateOutlet="t8"></ng-container>
  </div>
</div>

<div *ngIf="nav$ | async"></div>
<div *ngIf="interval$ | async"></div>
